import { z } from "zod";

export const projectRequestNoteFormSchema = z.object({
	note: z.string().min(1, "Bitte geben Sie eine Notiz ein."),
});

export type ProjectRequestNoteFormType = z.infer<typeof projectRequestNoteFormSchema>;
